import {
  LOCAL_STORAGE_NAME_JWT_ACCESS_EXPIRATION_TIME,
  LOCAL_STORAGE_NAME_JWT_REFRESH,
} from '../../constants/storage'
import { setStorageItem } from '../../utils/storage'

export function parseJWT(token) {
  const [header, payload, signature] = token.split('.')

  function decode(str) {
    return JSON.parse(atob(str.replace(/-/g, '+').replace(/_/g, '/')))
  }

  return {
    header: decode(header),
    payload: decode(payload),
    signature,
  }
}

export function persistRefreshedJWT(data) {
  const parsedAccessJWT = parseJWT(data.access)
  const now = Date.now()
  const expTime = Math.floor((parsedAccessJWT.payload.exp * 1000 - now) / 2)

  if (data.refresh) {
    setStorageItem(LOCAL_STORAGE_NAME_JWT_REFRESH, data.refresh)
  }

  setStorageItem(LOCAL_STORAGE_NAME_JWT_ACCESS_EXPIRATION_TIME, now + expTime)

  return expTime
}
